import { useConnectKit } from '../provider/ModalContext';

export function useConnectId() {
    const connectKit = useConnectKit();
    return connectKit?.cachedProviderId?.() || '';
}
